import React from "react";
import { connect } from "react-redux";
import * as actions from "modules/Session/actions";
import { getOtpMethod } from "../reducers";
import NewPatientForm from "./NewPatientForm";
import { trackEvent, trackButtonClick, setSessionContext } from "utils/analytics";

function NewPatient({ account, practiceId, addPatientRequest, otpMethod }) {
  return (
    <NewPatientForm
      onSubmit={(values) => {
        trackEvent("new_patient_submitted", {
          has_medicare: !!values.medicareNumber,
          has_dob: !!values.dateOfBirth,
        });
        trackButtonClick('submit_new_patient_button');
        // Patient ID will be set when response comes back
        setSessionContext({ patientType: 'new' });
        addPatientRequest(account, practiceId, values, otpMethod);
      }}
    />
  );
}

const mapStateToProps = (state) => ({ otpMethod: getOtpMethod(state.session) });

export default connect(mapStateToProps, actions)(NewPatient);
